import React from "react";
import PropTypes from "prop-types";
import SFTypography from "../../../typography";
import { SFStack } from "../../../grid";

const SFCellTextRenderer = (props) => {
  let customElement = props.colDef?.textComponent;
  //call any value formatters if they exist
  let value = props.colDef.valueFormatter
    ? props.colDef.valueFormatter(props)
    : props.value;

  return (
    <SFStack
      direction="row"
      alignItems={props.colDef.alignItems ?? "center"}
      sx={{ height: "100%" }}
    >
      {props.icon && props.icon}
      {customElement &&
        React.cloneElement(customElement, {
          props: customElement.props,
          children: value,
        })}
      {!customElement && (
        <SFTypography
          variant={props.colDef.textVariant ?? "tableCell"}
          textEllipsis
        >
          {value}
        </SFTypography>
      )}
    </SFStack>
  );
};

SFCellTextRenderer.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  textComponent: PropTypes.element,
  avatar: PropTypes.bool,
};

export default SFCellTextRenderer;
